import ProductCard from 'components/products/ProductCard';
import PropTypes from 'prop-types';
import React from 'react';
import { above } from 'utils/mediaqueries';
import productProp from 'utils/proptypes/product';
import styled from 'libs/styled';
import useAboveBreakpoint from 'hooks/useAboveBreakpoint';

const Wrapper = styled('ul')`
    display: flex;
    flex-wrap: wrap;

    @supports (display: grid) {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 32px 8px;
        padding: 32px 0;

        ${above.sm} {
            grid-template-columns: repeat(3, 1fr);
            gap: 32px 16px;
        }

        ${above.md} {
            gap: 56px 24px;
        }
    }
`;

const ProductCardWrapper = styled('li')`
    width: 50%;

    ${above.sm} {
        width: 33.33%;
    }

    @supports (display: grid) {
        width: auto !important;

        &:nth-of-type(5n) {
            grid-column-start: 1;
            grid-column-end: 3;
        }

        ${above.sm} {
            &:nth-of-type(5n) {
                grid-column-start: unset;
                grid-column-end: unset;
            }
            &:nth-of-type(5) {
                grid-column-start: 2;
                grid-column-end: 4;
                grid-row-start: 2;
                grid-row-end: 4;
            }
            &:nth-of-type(9) {
                grid-column-start: 1;
                grid-column-end: 3;
                grid-row-start: 5;
                grid-row-end: 7;
            }
        }
    }
`;

const ProductGrid = ({ products }) => {
    const isAboveSm = useAboveBreakpoint('sm');

    return (
        <Wrapper>
            {products.map((product, index) => {
                // Same logic as in ProductCardWrapper above
                const largeCard =
                    (isAboveSm && index === 4) || (isAboveSm && index === 8) || (!isAboveSm && (index + 1) % 5 === 0);

                return (
                    <ProductCardWrapper key={`${product.sku}_${product.uri}`}>
                        <ProductCard
                            imagePaddingTop={index === 4 || index === 8 ? ['0', null, '84px'] : undefined} // 58px info + 56px gap row - 24px column - 6px magic?
                            imageSizes={
                                largeCard
                                    ? ['100vw', null, '66.66vw', '66.66vw', '1300px']
                                    : ['50vw', null, '33.33vw', null, '650px']
                            }
                            largeLayout={largeCard}
                            position={index}
                            srcWidths={largeCard ? [375, 768, 682, 960, 1300] : [188, 384, 341, 480, 650]}
                            {...product}
                        />
                    </ProductCardWrapper>
                );
            })}
        </Wrapper>
    );
};

ProductGrid.propTypes = {
    products: PropTypes.arrayOf(productProp).isRequired,
};

export default ProductGrid;
